import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Entry } from 'contentful';
import { IAGPortalProductUpdateNotificationsPage } from 'src/app/model/page/group/iag-portal/iag-portal-product-update-notifications-page';
import { TableSection } from 'src/app/model/shared/table-section';
import { ApiService } from 'src/app/service/api.service';
import { entraAuthService } from 'src/app/service/auth.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ConfigService } from 'src/app/service/config.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';
import { config } from 'src/environments/environment';


@Component({
  selector: 'app-iag-portal-product-update-notifications-page',
  templateUrl: './iag-portal-product-update-notifications-page.component.html',
  styleUrls: ['./iag-portal-product-update-notifications-page.component.scss']
})
export class IagPortalProductUpdateNotificationsPageComponent {


  IAGPortalProductUpdateNotificationsPage: IAGPortalProductUpdateNotificationsPage = {} as IAGPortalProductUpdateNotificationsPage;

  tableDataMonthWiseGroups: Map<string, any> = new Map<string, any>();
  tableDataFilteredByData: Map<string, any> = new Map<string, any>();
  itemsToShowOnFirstLoad: Map<string, any> = new Map<string, any>();
  newItemsToShowOnFirstLoad: Map<string, any> = new Map<string, any>();
  tableDataToDisplayOnPageFirstLoad: Map<string, any> = new Map<string, any>();
  fromDate = '';
  toDate = '';
  filterButtonUsed: boolean = false;
  isUserLoggedIn = false;
  userId = '';
  productUpdateSubscribed = false;
  formattedStartDate = '';
  formattedEndDate = '';
  liveDate = '';

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private entraAuthService: entraAuthService, private apiService: ApiService, private router: Router, private configService: ConfigService) {}

  ngOnInit(): void {

    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-product-update-notifications') {
        this.IAGPortalProductUpdateNotificationsPage.htmlTitle = title.htmlTitle;
      }
    });
    this.IAGPortalProductUpdateNotificationsPage.productUpdateNotFound = false;
    this.IAGPortalProductUpdateNotificationsPage.tableSections = [];
    this.IAGPortalProductUpdateNotificationsPage.filteredTableData = [];
    const query = { 'fields.title': 'IAG Portal Product Update Notifications' };
    this.contentfulService.getPageContentResponse(query).then((IAGPortalProductUpdateNotificationsPageEntries) => {

      this.mapHtmlTitle(IAGPortalProductUpdateNotificationsPageEntries.items);
      this.mapBanners(IAGPortalProductUpdateNotificationsPageEntries.includes.Entry);
      this.mapPageInfo(IAGPortalProductUpdateNotificationsPageEntries.items);
      this.sharedDataService.addSharedData(this.IAGPortalProductUpdateNotificationsPage.banner);
      this.mapPages(IAGPortalProductUpdateNotificationsPageEntries.includes.Entry);


    });

    this.contentfulService.getIagRevisionNoticePageResponse().then((newNdcRevisionNoticePageEntriesqwe) => {
      this.mapNewPages(newNdcRevisionNoticePageEntriesqwe);

    });

    let token = this.entraAuthService.getTokenObject();

    if (token) {
      this.isUserLoggedIn = true;
      this.userId = token.idToken.claims.userID;
      this.getUserInformation(this.userId);
    } else {
      this.isUserLoggedIn = false;
    }
  }

  private mapHtmlTitle(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      this.IAGPortalProductUpdateNotificationsPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapBanners(IAGPortalProductUpdateNotificationsPageEntries: Entry<any>[]) {
    if (IAGPortalProductUpdateNotificationsPageEntries) {
      IAGPortalProductUpdateNotificationsPageEntries
        .filter((entry) => ModelValidator.isBanner(entry))
        .forEach((entry) => {
          this.mapEntryToBanner(entry);
        });
    }
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    this.IAGPortalProductUpdateNotificationsPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }

  getFormatDated(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  getStartAndEndDate() {
    const currentDate = new Date();
    const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 3, currentDate.getDate());
    this.formattedStartDate = this.getFormatDated(startDate);
    this.formattedEndDate = this.getFormatDated(currentDate);
  }

  private mapPageInfo(items: Entry<any>[]) {
    this.getStartAndEndDate();
    items.forEach((entry: any) => {
      this.fromDate = this.formattedEndDate;
      this.toDate = this.formattedStartDate;
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.IAGPortalProductUpdateNotificationsPage.banner.lastUpdated = entry.fields.lastUpdated !== undefined ? entry.fields.lastUpdated : '';
      this.IAGPortalProductUpdateNotificationsPage.banner.url = entry.fields.url;
      this.IAGPortalProductUpdateNotificationsPage.banner.editorEmail = editorDetails?.pop();
      this.IAGPortalProductUpdateNotificationsPage.banner.editorShortName = editorDetails?.pop();
      this.IAGPortalProductUpdateNotificationsPage.banner.editorFullName = editorDetails?.pop();

    });
  }

  private mapPages(IAGPortalProductUpdateNotificationsPageEntries: Entry<any>[]) {
    if (IAGPortalProductUpdateNotificationsPageEntries) {
      IAGPortalProductUpdateNotificationsPageEntries
        .filter((entry) => ModelValidator.isPage(entry))
        .forEach((entry) => {
          this.getTableData(entry);
        });


    }
    this.tableDataFilteredByData = new Map([...this.tableDataMonthWiseGroups].sort((a, b) => (a[0] > b[0] ? 1 : -1)));

    let liveDate = '';
    [...this.tableDataFilteredByData].forEach(([k, v]) => {
      v.forEach((item: { revisionNotices: any }) => {
        liveDate = item.revisionNotices[0].liveDate;
        if (this.fromDate >= liveDate && liveDate >= this.toDate) {
          if (this.itemsToShowOnFirstLoad.has(k)) {
            let itemsToDisplay = [item, ...this.itemsToShowOnFirstLoad.get(k)];
            this.itemsToShowOnFirstLoad.set(k, itemsToDisplay.sort((a, b) => (a.revisionNotices[0].liveDate > b.revisionNotices[0].liveDate ? 1 : -1)).reverse());
          } else {
            this.itemsToShowOnFirstLoad.set(k, [item].sort((a, b) => (a.revisionNotices[0].liveDate > b.revisionNotices[0].liveDate ? 1 : -1)).reverse());
          }
        }
      });
    });
    this.tableDataToDisplayOnPageFirstLoad = new Map([...this.itemsToShowOnFirstLoad]);

  }

  private mapNewPages(IAGPortalProductUpdateNotificationsPageEntries: Entry<any>[]) {
    if (IAGPortalProductUpdateNotificationsPageEntries) {
      IAGPortalProductUpdateNotificationsPageEntries
        .filter((entry) => ModelValidator.isIagProductUpdateNotification(entry))
        .forEach((entry) => {
          this.getNewTableData(entry);
        });

    }
    this.tableDataFilteredByData = new Map([...this.tableDataMonthWiseGroups].sort((a, b) => (a[0] > b[0] ? 1 : -1)));

    let liveDate = '';
    [...this.tableDataFilteredByData].forEach(([k, v]) => {
      v.forEach((item: { revisionNotices: any }) => {
        liveDate = item.revisionNotices[0].liveDate;
        if (this.fromDate >= liveDate && liveDate >= this.toDate) {
          if (this.newItemsToShowOnFirstLoad.has(k)) {
            let itemsToDisplay = [item, ...this.newItemsToShowOnFirstLoad.get(k)];
            this.newItemsToShowOnFirstLoad.set(k, itemsToDisplay.sort((a, b) => (a.revisionNotices[0].liveDate > b.revisionNotices[0].liveDate ? 1 : -1)).reverse());
          } else {
            this.newItemsToShowOnFirstLoad.set(k, [item].sort((a, b) => (a.revisionNotices[0].liveDate > b.revisionNotices[0].liveDate ? 1 : -1)).reverse());
          }
        }
      });
    });
    this.tableDataToDisplayOnPageFirstLoad = new Map([...this.newItemsToShowOnFirstLoad]);
  }

  private getTableData(entry: Entry<any>) {
    let liveDate: any = entry.fields['liveDate'];
    let dateInformation = this.getTableItemMonthAndYear(liveDate.trim());
    let tableItem = {
      title: entry.fields['title'] as string,
      body: '',
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string,
      ndcProductUpdateMonth: dateInformation.itemMonth,
      revisionNotices: [
        {
          liveDate: entry.fields['liveDate'] as string,
          status: entry.fields['status'] as string,
          title: entry.fields['htmlTitle'] as string,
          url: entry.fields['url'] as string,
          summary: entry.fields['summary'] as string,
          apiImpacted: entry.fields['apiImpacted'] as string,
          environment: entry.fields['environment'] as string,
          notification: entry.fields['notification'] as string
        }
      ]
    };

    this.mapTableData(tableItem, dateInformation.monthAndYearInDigits);

  }

  private getNewTableData(entry: Entry<any>) {
    if (entry.fields['liveDate'] !== undefined) {
      let liveDate: any = entry.fields['liveDate'];
      let dateInformation = this.getTableItemMonthAndYear(liveDate.trim());
      let tableItem = {
        title: entry.fields['pageTitle'] as string,
        body: '',
        order: entry.fields['tableOrder'] as number,
        group: entry.fields['group'] as string,
        ndcProductUpdateMonth: dateInformation.itemMonth,
        revisionNotices: [
          {
            liveDate: entry.fields['liveDate'] as string,
            status: entry.fields['status'] as string,
            title: entry.fields['htmlTitle'] as string,
            url: entry.fields['url'] as string,
            summary: entry.fields['summary'] as string,
            apiImpacted: entry.fields['apiImpacted'] as string,
            environment: entry.fields['environment'] as string,
            notification: entry.fields['notification'] as string
          }
        ]
      };

      this.mapTableData(tableItem, dateInformation.monthAndYearInDigits);
    }
  }

  private getTableItemMonthAndYear(liveDate: string) {
    let itemDate = new Date(String(liveDate));
    let itemYear = itemDate.getFullYear();
    let itemMonth = itemDate.toLocaleString('default', { month: 'long' });
    let monthAndYearInDigits = liveDate.slice(0, -3);

    let monthAndYear = `${itemMonth} ${itemYear}`;
    return { itemMonth, monthAndYear, monthAndYearInDigits };
  }

  private mapTableData(tableItem: TableSection, monthAndYear: string) {
    if (this.tableDataMonthWiseGroups.has(monthAndYear)) {
      let sortedProductUpdateInfo = [tableItem, ...this.tableDataMonthWiseGroups.get(monthAndYear)].sort((a, b) => (a.revisionNotices[0].liveDate > b.revisionNotices[0].liveDate ? 1 : -1)).reverse();

      this.tableDataMonthWiseGroups.set(monthAndYear, sortedProductUpdateInfo);
    } else {
      this.tableDataMonthWiseGroups.set(monthAndYear, [tableItem]);
    }
  }

  getRevisionNoticesWithinTheRange(startDate: any, endDate: any) {
    this.filterButtonUsed = true;
    this.IAGPortalProductUpdateNotificationsPage.productUpdateNotFound = false;
    this.tableDataFilteredByData = new Map();
    this.tableDataMonthWiseGroups.forEach((monthWiseData, key) => {
      monthWiseData.forEach((monthInfo: any) => {
        let itemDate = new Date(String(monthInfo.revisionNotices?.[monthInfo.revisionNotices?.length - 1]?.liveDate).trim());
        if ((itemDate <= startDate && itemDate >= endDate) || (itemDate >= startDate && itemDate <= endDate)) {
          if (this.tableDataFilteredByData.has(key)) {
            this.tableDataFilteredByData.set(
              key,
              [monthInfo, ...this.tableDataFilteredByData.get(key)].sort((a, b) => (a.revisionNotices[0].liveDate > b.revisionNotices[0].liveDate ? 1 : -1)).reverse()
            );
          } else {
            this.tableDataFilteredByData.set(key, [monthInfo]);
          }
        }
      });
    });

    this.tableDataFilteredByData.size === 0 ? (this.IAGPortalProductUpdateNotificationsPage.productUpdateNotFound = true) : (this.IAGPortalProductUpdateNotificationsPage.productUpdateNotFound = false);
  }

  redirectToLogin(): void {
    localStorage.setItem('redirect_url', '/profile');
    this.entraAuthService.initLogin();
  }

  async getUserInformation(userId: string) {
    const queryParams = new HttpParams()
      .append('id', userId)

    const apiResponse = await this.apiService.sendGetRequest('/user', queryParams);
    if (apiResponse?.success?.emailPreference?.iagPortals?.toLowerCase() === 'yes') {
      this.productUpdateSubscribed = true;
    }
  }

}
